// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__2zivk","avatarImg":"Avatar_avatarImg__9ZerX","avatarText":"Avatar_avatarText__2yH-x"};